import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const CustomersAndOrdersViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersView],
    permissions: [Permission.CustomersAndOrdersView],
  },
]

export const CustomerDetailViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [
      FeatureToggle.customersAndOrdersView,
      FeatureToggle.customersAndOrdersCustomerDetailView,
    ],
    permissions: [Permission.CustomersAndOrdersView],
  },
]

export const OrderDetailViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [
      FeatureToggle.customersAndOrdersView,
      FeatureToggle.customersAndOrdersOrderDetailView,
    ],
    permissions: [Permission.CustomersAndOrdersView],
  },
]
